import isEmpty from 'lodash/isEmpty';
import { SelfUserFlagQueryDocument } from '../queries/self-user-flag-query.gql-types';
import { UserFlagQueryDocument } from '../queries/user-flag-query.gql-types';
export default async ({ apolloClient, viewerUserId, viewerDisplayFlag, otherUserId, otherDisplayFlag, }) => {
    var _a, _b, _c, _d;
    const selfQuery = viewerUserId === otherUserId;
    const fetchedUserFlag = selfQuery
        ? await apolloClient.query({
            query: SelfUserFlagQueryDocument,
            variables: { displayFlag: viewerDisplayFlag },
            errorPolicy: 'all',
        })
        : await apolloClient.query({
            query: UserFlagQueryDocument,
            variables: {
                otherDisplayFlag,
                otherUserId: otherUserId,
                displayFlag: viewerDisplayFlag,
            },
            errorPolicy: 'all',
        });
    const userFlagInfo = selfQuery
        ? ((_b = (_a = fetchedUserFlag === null || fetchedUserFlag === void 0 ? void 0 : fetchedUserFlag.data) === null || _a === void 0 ? void 0 : _a.viewer) === null || _b === void 0 ? void 0 : _b.selfUserFlagDetails) || {}
        : ((_d = (_c = fetchedUserFlag === null || fetchedUserFlag === void 0 ? void 0 : fetchedUserFlag.data) === null || _c === void 0 ? void 0 : _c.viewer) === null || _d === void 0 ? void 0 : _d.otherUserFlagDetails) || {};
    return { error: isEmpty(userFlagInfo), fetchedInfo: userFlagInfo };
};
//# sourceMappingURL=fetch-user-flag.js.map